const CONTROL_DEFINITIONS = [
  {
    key: 'gravityStrength',
    label: 'Emotional Gravity',
    min: 0,
    max: 2,
    step: 0.01
  },
  {
    key: 'driftIntensity',
    label: 'Drift Intensity',
    min: 0,
    max: 2,
    step: 0.01
  },
  {
    key: 'repulsionStrength',
    label: 'Repulsion Strength',
    min: 0,
    max: 2,
    step: 0.01
  },
  {
    key: 'clusterStabilization',
    label: 'Cluster Stabilization',
    min: 0,
    max: 2,
    step: 0.01
  }
]

export default class GenomeControls {
  init(root, { state, onChange }) {
    this.state = state
    this.onChange = onChange
    this.values = new Map()
    this.inputs = new Map()

    this.element = document.createElement('aside')
    this.element.className = 'controls-panel'
    this.element.innerHTML = `
      <div class="controls-panel__title">FIELD DYNAMICS</div>
      <div class="controls-panel__body"></div>
    `

    const body = this.element.querySelector('.controls-panel__body')

    CONTROL_DEFINITIONS.forEach(control => {
      const row = document.createElement('label')
      row.className = 'controls-panel__row'
      row.innerHTML = `
        <div class="controls-panel__row-head">
          <span>${control.label}</span>
          <strong data-value="${control.key}"></strong>
        </div>
        <input
          data-control="${control.key}"
          type="range"
          min="${control.min}"
          max="${control.max}"
          step="${control.step}"
          value="${state.dynamics[control.key]}"
        />
      `

      const input = row.querySelector('input')
      const value = row.querySelector(`[data-value="${control.key}"]`)

      input.addEventListener('input', () => {
        this.onChange(control.key, Number(input.value))
        this.renderValues()
      })

      this.inputs.set(control.key, input)
      this.values.set(control.key, value)
      body.appendChild(row)
    })

    root.appendChild(this.element)
    this.renderValues()
  }

  renderValues() {
    CONTROL_DEFINITIONS.forEach(control => {
      const value = this.state.dynamics[control.key]
      const input = this.inputs.get(control.key)
      const output = this.values.get(control.key)

      if (input) {
        input.value = String(value)
      }

      if (output) {
        output.textContent = value.toFixed(2)
      }
    })
  }
}
